import { api, unwrap } from '@saas-kit/lib';

/** Outcome of asking the backend to render and (optionally) deliver a token. */
export interface TokenPrintResult {
  /** True when the backend itself delivered the receipt (network printer or
   *  a connected print agent); false leaves delivery to the client. */
  sent: boolean;
  /** Transport the server used: `noop` (client delivers), `network`, or
   *  `agent` (pushed to the tenant's on-LAN print agent). */
  transport: string;
  byte_count: number;
  /** Raw ESC/POS bytes, base64-encoded — present whether or not `sent`. */
  payload_base64: string;
  detail: string | null;
}

/** Render a token to ESC/POS. With the `noop` transport the server returns
 *  the payload for the workstation to deliver over Web Serial. */
export async function printToken(tokenId: string): Promise<TokenPrintResult> {
  return unwrap<TokenPrintResult>(api.post(`/qms/tokens/${tokenId}/print`));
}
